import { colorCreatorWithRange } from '../../utils/colorUtils';
import StyleFactory, { getNumberFromFeatureProps, getAreaLabelFromFeature, getAreaValueFromFeature, getLineValueFromFeature } from '../../StyleFactory';
const labels = ['', 'Light', 'Moderate', 'Severe', 'Very severe'];
export const themeSelector = (value, theme) => ({
  color: colorCreatorWithRange(theme.color, value, theme.min, theme.max)
});

const getLabelByValue = value => {
  let index = Math.ceil(value);
  index = Math.max(index, 0);
  index = Math.min(index, labels.length);
  return labels[index];
};

const labelSelector = feature => {
  const value = getNumberFromFeatureProps()(feature);
  return getLabelByValue(value);
};

const areaLabelSelector = feature => {
  const value = getAreaLabelFromFeature(feature);
  return getLabelByValue(value);
};

const gridViewStyle = StyleFactory.createStyle({
  valueSelector: getNumberFromFeatureProps(),
  labelSelector: labelSelector,
  themeSelector
});
const isolineViewStyle = StyleFactory.createStyle({
  valueSelector: getLineValueFromFeature,
  labelSelector: labelSelector,
  themeSelector
});
const areaViewStyle = StyleFactory.createStyleWithLabel({
  labelSelector: areaLabelSelector,
  valueSelector: getAreaValueFromFeature,
  themeSelector
});
export default {
  grid: gridViewStyle,
  line: isolineViewStyle,
  area: areaViewStyle
};